export enum EmailTriggersEnum {
  PRIZE_WINNING = 'winning',
  GAME_END = 'game_end',
  ON_DATE = 'on_date',
  NEW_LEAD = 'new_lead',
  UNEXPECTED_GAME_END = 'unexpected_game_end'
}
